/* Filtary shower-filter CARTRIDGE PDP runtime.
   Standalone: filtary-pdp-runtime.js is NOT loaded on this page. The bundles
   pick a QUANTITY (name="flt-qty") of the single variant; the variant id and
   quantity live on hidden inputs so the global WhatsApp injector keeps working.
   renderCart()/openCart() are copied from filtary-pdp-runtime.js. */
(function(){
  if(window.__fltCartridgeBound)return;
  window.__fltCartridgeBound=true;

  var root=function(){return document.getElementById('flt-lp');};
  var form=function(){return document.getElementById('flt-form');};

  function submitButtons(f){
    var set=[];
    var seen=new Set();
    function add(list){Array.prototype.forEach.call(list,function(b){if(!seen.has(b)){seen.add(b);set.push(b);}});}
    add(f.querySelectorAll('button[type="submit"]'));
    add(document.querySelectorAll('button[form="flt-form"][type="submit"]'));
    return set;
  }

  /* ---- Bundle (quantity) selection ---- */
  function priceMarkup(price){
    return '<div class="price-now">'+price+' <span class="cur">IQD</span></div>';
  }

  function syncQty(radio){
    var lp=root();
    if(!lp||!radio)return;
    var label=radio.closest('.bundle');
    var qty=radio.getAttribute('data-qty')||radio.value||'1';
    var price=radio.getAttribute('data-price')||'';
    lp.querySelectorAll('.bundle').forEach(function(x){x.classList.remove('active');});
    if(label)label.classList.add('active');

    var qtyInput=document.getElementById('flt-qty-input');
    if(qtyInput)qtyInput.value=qty;

    var priceRow=lp.querySelector('#flt-price');
    if(priceRow)priceRow.innerHTML=priceMarkup(price);
    var stickyPrice=lp.querySelector('#flt-sticky-price');
    if(stickyPrice)stickyPrice.textContent=price+' IQD';
    var finalPriceRow=lp.querySelector('#flt-final-price');
    if(finalPriceRow)finalPriceRow.innerHTML=priceMarkup(price);

    /* Let the global WhatsApp injector re-read the new quantity. */
    if(qtyInput){
      try{qtyInput.dispatchEvent(new Event('change',{bubbles:true}));}catch(e){}
    }
  }

  document.addEventListener('change',function(event){
    var t=event.target;
    if(t&&t.closest&&t.closest('#flt-form')&&t.matches&&t.matches('input[name="flt-qty"]')&&t.checked){
      syncQty(t);
    }
  });

  /* ---- Sticky bar (setTimeout paced; never requestAnimationFrame) ---- */
  var stickyPending=false;
  function updateSticky(){
    var lp=root();if(!lp)return;
    var sticky=lp.querySelector('#flt-sticky');
    var heroButton=lp.querySelector('#flt-form .hero button[type="submit"]');
    if(!sticky||!heroButton)return;
    sticky.classList.toggle('show',heroButton.getBoundingClientRect().bottom<0);
  }
  function queueSticky(){
    if(stickyPending)return;
    stickyPending=true;
    setTimeout(function(){stickyPending=false;updateSticky();},60);
  }

  /* ---- Cart rendering (copied from filtary-pdp-runtime.js) ---- */
  function renderCart(sections){
    if(!sections)return;
    var drawerHtml=sections['cart-drawer'];
    if(drawerHtml){
      var parsed=new DOMParser().parseFromString(drawerHtml,'text/html');
      var fresh=parsed.querySelector('cart-drawer');
      var live=document.querySelector('cart-drawer');
      if(fresh&&live)live.replaceWith(document.importNode(fresh,true));
    }
    var bubbleHtml=sections['cart-icon-bubble'];
    if(bubbleHtml){
      var liveBubble=document.getElementById('cart-icon-bubble');
      if(liveBubble){
        var parsedBubble=new DOMParser().parseFromString(bubbleHtml,'text/html');
        liveBubble.innerHTML=(parsedBubble.querySelector('.shopify-section')||parsedBubble.body).innerHTML;
      }
    }
  }

  function openCart(){
    var drawer=document.querySelector('cart-drawer');
    if(drawer&&typeof drawer.open==='function'){try{drawer.open();return;}catch(error){}}
    var icon=document.querySelector('a[href="/cart"],a[href^="/cart"],.header__icon--cart,#cart-icon-bubble');
    if(icon){icon.click();return;}
    if(drawer){
      drawer.classList.remove('is-empty');
      drawer.classList.add('animate','active');
      document.body.classList.add('overflow-hidden');
    }
  }

  /* ---- Submit: cart.js read → change.js (present) or add.js (absent) ---- */
  document.addEventListener('submit',function(event){
    var activeForm=form();
    if(!activeForm||event.target!==activeForm)return;
    event.preventDefault();
    handleSubmit(activeForm,event.submitter);
  });

  function nativeSubmit(f){
    try{HTMLFormElement.prototype.submit.call(f);}catch(e){f.submit();}
  }

  function handleSubmit(activeForm,submitter){
    if(activeForm.dataset.fltSubmitting==='1')return;
    var idInput=activeForm.querySelector('input[name="id"]');
    var variantId=idInput?idInput.value:'';
    var qtyInput=document.getElementById('flt-qty-input');
    var qty=parseInt((qtyInput&&qtyInput.value)||'1',10);
    if(!variantId||!(qty>0)){nativeSubmit(activeForm);return;}

    activeForm.dataset.fltSubmitting='1';
    var buttons=submitButtons(activeForm);
    var btn=submitter||buttons[0];
    var originalText=btn?btn.innerHTML:'';
    buttons.forEach(function(b){b.disabled=true;b.style.opacity='.7';});

    var shopRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    var sections=['cart-drawer','cart-icon-bubble'];

    function fail(){
      buttons.forEach(function(b){b.disabled=false;b.style.opacity='';});
      delete activeForm.dataset.fltSubmitting;
      nativeSubmit(activeForm);
    }

    function succeed(data){
      try{
        renderCart(data&&data.sections);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
      }catch(e){}
      buttons.forEach(function(b){b.style.opacity='';});
      if(btn){
        btn.innerHTML='تمت الإضافة ✓';
        btn.style.setProperty('background-color','#10b981','important');
        btn.style.color='#fff';
      }
      setTimeout(openCart,150);
      setTimeout(function(){
        buttons.forEach(function(b){b.disabled=false;});
        if(btn){
          btn.innerHTML=originalText;
          btn.style.removeProperty('background-color');
          btn.style.color='';
        }
        delete activeForm.dataset.fltSubmitting;
      },2500);
    }

    fetch(shopRoot+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
      .then(function(r){if(!r.ok)throw new Error('cart-read');return r.json();})
      .then(function(cart){
        var items=(cart&&Array.isArray(cart.items))?cart.items:[];
        var present=items.some(function(it){return String(it.variant_id!=null?it.variant_id:it.id)===String(variantId)&&Number(it.quantity)>0;});
        var url,body;
        if(present){
          url=shopRoot+'cart/change.js';
          body={id:variantId,quantity:qty,sections:sections,sections_url:location.pathname};
        }else{
          url=shopRoot+'cart/add.js';
          body={items:[{id:variantId,quantity:qty}],sections:sections,sections_url:location.pathname};
        }
        return fetch(url,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body:JSON.stringify(body)
        });
      })
      .then(function(r){return r.json().then(function(data){return{ok:r.ok,data:data};});})
      .then(function(res){
        if(!res.ok||(res.data&&res.data.status&&!res.data.items&&!res.data.item_count))throw new Error('cart-write');
        succeed(res.data);
      })
      .catch(function(){fail();});
  }

  /* ---- Init ---- */
  function init(){
    var activeForm=form();
    var checked=activeForm&&activeForm.querySelector('input[name="flt-qty"]:checked');
    if(checked)syncQty(checked);
    updateSticky();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();

  window.addEventListener('scroll',queueSticky,{passive:true});
  window.addEventListener('resize',queueSticky,{passive:true});
  document.addEventListener('shopify:section:load',init);
})();
